// extracted by mini-css-extract-plugin
module.exports = {"venue":"_cdf413d","wrapper":"_9bd8994","cardWrapper":"_cef153d","tabsWrapper":"_b1aea14"};